import React from 'react';

import { FormattedMessage } from 'react-intl';

import WarningIcon from '@atlaskit/icon/glyph/warning';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { CopyableTextFieldStateless } from '@atlassian/bitkit-copy';

import messages from './ref-copy-field.i18n';
import * as styles from './ref-copy-field.styled';

interface RefCopyFieldProps {
  refName: string;
}

const isSafeRefName = (refName: string): boolean => {
  return refName.match(/^[A-Za-z0-9/\-._]+$/) !== null;
};

export const RefCopyField = ({ refName }: RefCopyFieldProps): JSX.Element => {
  const branchCharacterWarning = (
    <FormattedMessage {...messages.branchCharacterWarning} />
  );

  return (
    <>
      {isSafeRefName(refName) ? (
        <CopyableTextFieldStateless
          isReadOnly
          value={`git checkout ${refName}`}
        />
      ) : (
        <styles.WarningCopyWrapper>
          <Tooltip position="bottom" content={branchCharacterWarning}>
            <styles.WarningIconWrapper>
              <WarningIcon
                label="malicious-characters-warning"
                primaryColor={token('color.icon.warning', colors.Y400)}
              />
            </styles.WarningIconWrapper>
          </Tooltip>
          <styles.WarningBranchCopyWrapper>
            <CopyableTextFieldStateless isReadOnly value={refName} />
          </styles.WarningBranchCopyWrapper>
        </styles.WarningCopyWrapper>
      )}
    </>
  );
};

export default RefCopyField;
